import React from "react";
import { connect } from "react-redux";
import selectExpense from "../selectors/expenses";
import ExpensesListItem from "./ExpenseListItem";

const ExpenseList = (props) => (
  <div className="container">
    <div className="list-header">
      <div className="show-for-mobile">Expenses</div>
      <div className="show-for-desktop">Expenses</div>
      <div className="show-for-desktop">Amount</div>
    </div>
    <div className="list-body">
      {props.expenses.length === 0 ? (
        <div className="list-item list-item--message">
          <span>No expenses</span>
        </div>
      ) : (
        props.expenses.map((expense) => {
          return <ExpensesListItem key={expense.id} {...expense} />;
        })
      )}
    </div>
  </div>
);

const mapStateTpProps = (state) => {
  return {
    expenses: selectExpense(state.expenses, state.filters),
  };
};
export default connect(mapStateTpProps)(ExpenseList);
